import { createFetcher } from '../../Common';

import {
  CALENDAR_SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT,
  getBaseUrl,
  SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT,
  SERVICES_AUTH_TOKEN_ENDPOINT,
} from '../../constants';

class Services {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Services(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.generate_ath_tokens = SERVICES_AUTH_TOKEN_ENDPOINT;
    this.serviceConfigurationsRefreshEndpoint = SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT;
    this.calendarServiceConfigurationRefreshEndpoint =
      CALENDAR_SERVICE_CONFIGURATIONS_REFRESH_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async postGenerateAuthTokens(reqBody) {
    let body = reqBody;
    let isUserToken = false;
    if (!Array.isArray(body)) {
      body = reqBody?.reqBody;
      isUserToken = reqBody?.isUserCalendar;
    }
    const url = `${this.base_url}${this.generate_ath_tokens}${
      isUserToken ? '?isUserCalendar=true' : ''
    }`;
    const response = await this.fetcher.postData(url, body);
    return response?.data;
  }

  async getServiceRefreshTokens() {
    const url = `${this.base_url}${this.serviceConfigurationsRefreshEndpoint}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async putGenerateAuthTokens(reqBody) {
    const url = `${this.base_url}${this.serviceConfigurationsRefreshEndpoint}`;
    const response = await this.fetcher.putData(url, reqBody);
    return response?.data;
  }

  async putCalendarGenerateAuthTokens(args) {
    const { reqBody, userId } = args;
    const url = `${this.base_url}${this.calendarServiceConfigurationRefreshEndpoint}/${userId}`;
    const response = await this.fetcher.putData(url, reqBody);
    return response?.data;
  }
}

export const createServices = () => Services.getInstance();
